import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { MasterDataCommon } from '../master-data.common';
import { CommonMessageService } from 'src/app/services/common-message.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-assignment',
  templateUrl: './manage-assignment.component.html',
  styleUrls: ['./manage-assignment.component.css']
})
export class ManageAssignmentComponent implements OnInit {
  modalStatus='';
  closeResult = '';
  modalForm;
  assignmentList:any;
  assignmentListTemp:any;
  formSubmitted=false;
  formErrors = MasterDataCommon.assignmentFormErrors;
  formValidationMessages = MasterDataCommon.assignmentFormValidationMessages;

  constructor(private modalService: NgbModal,private fb: FormBuilder,private masterDataService:MasterDataService,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadAssignments()
  }

  openModal(content,status) {
    let ngbModalOptions: NgbModalOptions  = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      windowClass : "animate__animated animate__slideInUp animate__faster",
      backdrop : 'static',
      keyboard : false
    }
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      name :  ['', [Validators.required,Validators.maxLength(50)]],
      id:['']
    });
  }
  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }


  loadAssignments(){
    this.masterDataService.getAssignments()
    .subscribe(res => {
      console.log(res);
      this.assignmentList = res;
    });
  }

  changeAssignmentList(assignment){
    if(this.modalStatus=='add'){
      this.assignmentList.push(assignment);
    }

    if(this.modalStatus=='edit'){
      // var item = this.diaryList.find(item => item.id === diary.id);
      // console.log(item);
      var index = this.assignmentList.findIndex(item => item.id === assignment.id)
      console.log(index);
      this.assignmentList.splice(index, 1, assignment);
      console.log(this.assignmentList);
    }

    if(this.modalStatus=='delete'){
      var index = this.assignmentList.findIndex(item => item.id === assignment.id)
      console.log(index);
      this.assignmentList.splice(index, 1);
    }
  }

  onDeleteClick(assignment){
    console.log(assignment);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
      this.masterDataService.deleteAssignment(assignment)
      .subscribe(resp => {
        console.log(resp);
        this.changeAssignmentList(assignment);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
  }

  onSaveClick(){
    console.log(this.modalForm.value);
    console.log(this.modalForm);
    console.log(this.formErrors);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.saveAssignment(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.changeAssignmentList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
      })
    }
  }

  onEditClick(modalContent,assignment){
    console.log(assignment);
    this.modalForm.patchValue({
      name: assignment.name,
      id:assignment.id
    });
    this.openModal(modalContent,'edit');
  }

  onUpdateClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.updateAssignment(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.changeAssignmentList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');

      })
    }
  }

  logValidationErrors(group: FormGroup): void {
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid && this.formSubmitted) {
        const messages = this.formValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          console.log(errorKey)
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }
    }
  });
}

}
